// Location Page Components - Organized exports
export { default as TipStaffTab } from './TipStaffTab';
export { default as SendDrinkModal, DRINK_OPTIONS } from './SendDrinkModal';
export { default as DMModal } from './DMModal';
export { default as SongRequestModal } from './SongRequestModal';

// Constants used across location page components
export const AVATAR_EMOJIS = ['😊', '😎', '🤩', '🥳', '😋', '🍗', '🦐', '🍹', '🔥', '💯', '🎉', '✨'];
export const MOODS = ['Vibing', 'Hungry', 'Celebrating', 'Date Night', 'Girls Night', 'With Friends', 'Solo Dining', 'Business Dinner'];
export const TIP_AMOUNTS = [5, 10, 20, 50, 100];
export const STAFF_TIP_AMOUNTS = [10, 20, 50, 100];
